import { AlertSpg, FormSection, GridItem, GridContainer } from "@duosoftbg/nacid-components";
import {
  IdentifierType,
  NaturalPersonBirthFormFields,
  NaturalPersonAdditionalFormFields,
  NaturalPersonIdentifierFormFields,
  NaturalPersonNamesFormFields,
  NaturalPersonHumanitarianStatusFormFields,
  NaturalPersonTitleFormFields,
} from "@duosoftbg/nacid-frontoffice-components";
import { useFormContext, useWatch } from "react-hook-form";
import React from "react";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { countriesDataThunk } from "../../../../../../store/redux/slice/AppData/countriesData";
import { getExtractedBirthDate, getSettlement, getSettlementsAutocomplete } from "../../../../../../axios/api/services";
import { foreignIdThunk } from "../../../../../../store/redux/slice/AppData/foreignId";
import { humanitarianStatusThunk } from "../../../../../../store/redux/slice/AppData/humanitarianStatus";

const PersonFormSection = () => {
  const { t } = useTranslation();
  const { getValues } = useFormContext();

  const thunkStateCountries = useAppSelector((state) => {
    return state.AppData.countriesData;
  });

  const thunkStateForeignId = useAppSelector((state) => {
    return state.AppData.foreignId;
  });

  const thunkStateHumanitarianStatus = useAppSelector((state) => {
    return state.AppData.humanitarianStatus;
  });

  useWatch({ name: "personalIdType" });
  useWatch({ name: "birthCountry" });
  useWatch({ name: "citizenship" });

  const showMiddleNameAlert = () => getValues().birthCountry !== "BG" && getValues().citizenship === "BG";

  return (
    <FormSection label={"t.personal.details"}>
      {showMiddleNameAlert() && (
        <GridItem md={12}>
          <AlertSpg mt={1} severity="info">
            {t("m.middleName.required.if.exists")}
          </AlertSpg>
        </GridItem>
      )}

      <GridContainer spacing={4} mt={0}>
        <NaturalPersonNamesFormFields
          baseField={null}
          firstNameRequired={true}
          middleNameRequired={getValues().birthCountry.id === "BG" && getValues().citizenship.id === "BG"}
          lastNameRequired={
            getValues().citizenship.id === "BG" || getValues().personalIdType === IdentifierType.NATIONAL_ID
          }
        />

        <NaturalPersonIdentifierFormFields
          baseField={null}
          countriesThunkState={thunkStateCountries}
          countriesThunk={countriesDataThunk}
          foreignIdThunk={foreignIdThunk}
          foreignIdThunkState={thunkStateForeignId}
        />

        <NaturalPersonHumanitarianStatusFormFields
          humanitarianStatusThunk={humanitarianStatusThunk}
          humanitarianStatusThunkState={thunkStateHumanitarianStatus}
          baseField={null}
        />

        <NaturalPersonBirthFormFields
          baseField={null}
          countryRequired={false}
          placeRequired={false}
          dateRequired={false}
          countriesThunkState={thunkStateCountries}
          countriesThunk={countriesDataThunk}
          getSettlementsAutocomplete={getSettlementsAutocomplete}
          getSettlement={getSettlement}
          getExtractedBirthDate={getExtractedBirthDate}
        />
        <NaturalPersonAdditionalFormFields
          baseField={null}
          showEmail={false}
          emailRequired={false}
          citizenshipRequired={false}
          countriesThunkState={thunkStateCountries}
          countriesThunk={countriesDataThunk}
        />
        <NaturalPersonTitleFormFields baseField={null} />
      </GridContainer>
    </FormSection>
  );
};
export default PersonFormSection;
